import GC12AM from "./assets/GC12AM.mp3";
import GC1AM from "./assets/GC1AM.mp3";
import GC2AM from "./assets/GC2AM.mp3";
import GC3AM from "./assets/GC3AM.mp3";
import GC4AM from "./assets/GC4AM.mp3";
import GC5AM from "./assets/GC5AM.mp3";
import GC6AM from "./assets/GC6AM.mp3";
import GC7AM from "./assets/GC7AM.mp3";
import GC8AM from "./assets/GC8AM.mp3";
import GC9AM from "./assets/GC9AM.mp3";
import GC10AM from "./assets/GC10AM.mp3";
import GC11AM from "./assets/GC11AM.mp3";
import GC12PM from "./assets/GC12PM.mp3";
import GC1PM from "./assets/GC1PM.mp3";
import GC2PM from "./assets/GC2PM.mp3";
import GC3PM from "./assets/GC3PM.mp3";
import GC4PM from "./assets/GC4PM.mp3";
import GC5PM from "./assets/GC5PM.mp3";
import GC6PM from "./assets/GC6PM.mp3";
import GC7PM from "./assets/GC7PM.mp3";
import GC8PM from "./assets/GC8PM.mp3";
import GC9PM from "./assets/GC9PM.mp3";
import GC10PM from "./assets/GC10PM.mp3";
import GC11PM from "./assets/GC11PM.mp3";
import CF12AM from "./assets/CF12AM.mp3";
import CF1AM from "./assets/CF1AM.mp3";
import CF2AM from "./assets/CF2AM.mp3";
import CF3AM from "./assets/CF3AM.mp3";
import CF4AM from "./assets/CF4AM.mp3";
import CF5AM from "./assets/CF5AM.mp3";
import CF6AM from "./assets/CF6AM.mp3";
import CF7AM from "./assets/CF7AM.mp3";
import CF8AM from "./assets/CF8AM.mp3";
import CF9AM from "./assets/CF9AM.mp3";
import CF10AM from "./assets/CF10AM.mp3";
import CF11AM from "./assets/CF11AM.mp3";
import CF12PM from "./assets/CF12PM.mp3";
import CF1PM from "./assets/CF1PM.mp3";
import CF2PM from "./assets/CF2PM.mp3";
import CF3PM from "./assets/CF3PM.mp3";
import CF4PM from "./assets/CF4PM.mp3";
import CF5PM from "./assets/CF5PM.mp3";
import CF6PM from "./assets/CF6PM.mp3";
import CF7PM from "./assets/CF7PM.mp3";
import CF8PM from "./assets/CF8PM.mp3";
import CF9PM from "./assets/CF9PM.mp3";
import CF10PM from "./assets/CF10PM.mp3";
import CF11PM from "./assets/CF11PM.mp3";
import NL12AM from "./assets/NL12AM.mp3";
import NL1AM from "./assets/NL1AM.mp3";
import NL2AM from "./assets/NL2AM.mp3";
import NL3AM from "./assets/NL3AM.mp3";
import NL4AM from "./assets/NL4AM.mp3";
import NL5AM from "./assets/NL5AM.mp3";
import NL6AM from "./assets/NL6AM.mp3";
import NL7AM from "./assets/NL7AM.mp3";
import NL8AM from "./assets/NL8AM.mp3";
import NL9AM from "./assets/NL9AM.mp3";
import NL10AM from "./assets/NL10AM.mp3";
import NL11AM from "./assets/NL11AM.mp3";
import NL12PM from "./assets/NL12PM.mp3";
import NL1PM from "./assets/NL1PM.mp3";
import NL2PM from "./assets/NL2PM.mp3";
import NL3PM from "./assets/NL3PM.mp3";
import NL4PM from "./assets/NL4PM.mp3";
import NL5PM from "./assets/NL5PM.mp3";
import NL6PM from "./assets/NL6PM.mp3";
import NL7PM from "./assets/NL7PM.mp3";
import NL8PM from "./assets/NL8PM.mp3";
import NL9PM from "./assets/NL9PM.mp3";
import NL10PM from "./assets/NL10PM.mp3";
import NL11PM from "./assets/NL11PM.mp3";
import NH12AM from "./assets/NH12AM.mp3";
import NH1AM from "./assets/NH1AM.mp3";
import NH2AM from "./assets/NH2AM.mp3";
import NH3AM from "./assets/NH3AM.mp3";
import NH4AM from "./assets/NH4AM.mp3";
import NH5AM from "./assets/NH5AM.mp3";
import NH6AM from "./assets/NH6AM.mp3";
import NH7AM from "./assets/NH7AM.mp3";
import NH8AM from "./assets/NH8AM.mp3";
import NH9AM from "./assets/NH9AM.mp3";
import NH10AM from "./assets/NH10AM.mp3";
import NH11AM from "./assets/NH11AM.mp3";
import NH12PM from "./assets/NH12PM.mp3";
import NH1PM from "./assets/NH1PM.mp3";
import NH2PM from "./assets/NH2PM.mp3";
import NH3PM from "./assets/NH3PM.mp3";
import NH4PM from "./assets/NH4PM.mp3";
import NH5PM from "./assets/NH5PM.mp3";
import NH6PM from "./assets/NH6PM.mp3";
import NH7PM from "./assets/NH7PM.mp3";
import NH8PM from "./assets/NH8PM.mp3";
import NH9PM from "./assets/NH9PM.mp3";
import NH10PM from "./assets/NH10PM.mp3";
import NH11PM from "./assets/NH11PM.mp3";

// includes all the audio files in a const audioFiles
const audioFiles = {
    GC12AM, GC1AM, GC2AM, GC3AM, GC4AM, GC5AM, GC6AM, GC7AM, GC8AM, GC9AM, GC10AM, GC11AM, GC12PM, GC1PM, GC2PM, GC3PM, GC4PM, GC5PM, GC6PM, GC7PM, GC8PM, GC9PM, GC10PM, GC11PM,
    CF12AM, CF1AM, CF2AM, CF3AM, CF4AM, CF5AM, CF6AM, CF7AM, CF8AM, CF9AM, CF10AM, CF11AM, CF12PM, CF1PM, CF2PM, CF3PM, CF4PM, CF5PM, CF6PM, CF7PM, CF8PM, CF9PM, CF10PM, CF11PM,
    NL12AM, NL1AM, NL2AM, NL3AM, NL4AM, NL5AM, NL6AM, NL7AM, NL8AM, NL9AM, NL10AM, NL11AM, NL12PM, NL1PM, NL2PM, NL3PM, NL4PM, NL5PM, NL6PM, NL7PM, NL8PM, NL9PM, NL10PM, NL11PM,
    NH12AM, NH1AM, NH2AM, NH3AM, NH4AM, NH5AM, NH6AM, NH7AM, NH8AM, NH9AM, NH10AM, NH11AM, NH12PM, NH1PM, NH2PM, NH3PM, NH4PM, NH5PM, NH6PM, NH7PM, NH8PM, NH9PM, NH10PM, NH11PM
};

export default audioFiles;
